import React from "react";
import HubGrid from "./HubGrid";

/**
 * Renders one nav "item" from a hub*Links.js data file:
 *
 * - Section title
 * - Section icon
 * - Child navigation links
 *
 * Existing permission and visibility behavior is preserved.
 */
const HubSection = ({
  title,
  icon: Icon,
  links = [],
  isPortal = false,
  basePath = "/staff-panel",
  hasPermission = () => true,
}) => {
  /**
   * Determine whether at least one link should be visible.
   *
   * This intentionally mirrors HubGrid's filtering logic so that
   * empty sections are not rendered.
   */
  const hasVisibleLinks = links.some((link) => {
    // Owner view
    if (!isPortal) {
      return !link.ownerHidden;
    }

    // Portal view
    if (link.permission === null || link.permission === undefined) {
      return false;
    }

    return typeof hasPermission === "function"
      ? hasPermission(link.permission)
      : true;
  });

  // Don't render empty sections.
  if (!hasVisibleLinks) {
    return null;
  }

  return (
    <section className="mb-8">
      {/* Section heading */}
      <div className="flex items-center gap-2 mb-4">
        {Icon && (
          <Icon
            className="w-4 h-4 text-gray-400 dark:text-neutral-500"
            strokeWidth={1.8}
          />
        )}

        <h2 className="text-xs font-semibold text-gray-400 dark:text-neutral-500 uppercase tracking-wider">
          {title}
        </h2>
      </div>

      {/* Section navigation cards */}
      <HubGrid
        links={links}
        isPortal={isPortal}
        basePath={basePath}
        hasPermission={hasPermission}
      />
    </section>
  );
};

export default HubSection;